import React, { useState, useEffect } from 'react';
import {
  Card,
  CardBody,
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { NotificationManager } from '../../../../../../components/common/react-notifications';

export default function Settings({
  integrationId,
  saveIntegration,
  channelDetails,
  existingSettings = {},
}) {
  const [settings, setSettings] = useState(channelDetails.settings || {
    clientId: '',
    clientSecret: '',
    tenantId: '',
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (existingSettings && Object.keys(existingSettings).length > 0) {
      setSettings({
        clientId: existingSettings.clientId || '',
        clientSecret: existingSettings.clientSecret || '',
        tenantId: existingSettings.tenantId || '',
      });
    }
  }, [existingSettings]);

  const handleChange = (e) => {
    setSettings({
      ...settings,
      [e.target.name]: e.target.value,
    });
  };

  const handleSave = async () => {
    let detailts = channelDetails || {};
    detailts.settings = settings;
    saveIntegration({ channelDetails: detailts });
  };

  return (
    <Card className="mb-4">
      <CardBody>
        <div className="text-center mb-2">
          <h6>Register App in Microsoft Entra ID</h6>
        </div>
        <Separator className="mx-3"/>
        <div className=" p-3" style={{}}>

          <Row>
            <Col md={12}>
              <ol style={{ listStyle: 'none' }}>
                <li style={{ marginBottom: 10, lineHeight: 1.5 }}>
                  <span style={{ fontWeight: 500, fontSize: 15 }}>Step 1: Register app in Microsoft Entra ID</span>
                  <ul style={{ marginTop: 5, paddingLeft: 50, lineHeight: 1.5 }}>
                    <li style={{ marginBottom: 6, fontSize: 14 }}>Go to <span style={{ fontWeight: 500 }}>Entra ID → App registrations</span></li>
                    <li style={{ marginBottom: 6, fontSize: 14 }}>Create a new app named <span style={{ fontWeight: 500 }}>email-automation</span></li>
                    <li style={{ marginBottom: 6, fontSize: 14 }}>Add API permissions (Application type): <span style={{ fontWeight: 500 }}>Mail.ReadWrite</span> and <span style={{ fontWeight: 500 }}>Mail.Send</span></li>
                    <li style={{ marginBottom: 6, fontSize: 14 }}>Under <span style={{ fontWeight: 500 }}>Certificates & secrets</span>, create a new client secret named <span style={{ fontWeight: 500 }}>email-automation-secret</span></li>
                    <li style={{ marginBottom: 0, fontSize: 14 }}>Copy the <span style={{ fontWeight: 500 }}>Tenant ID</span>, <span style={{ fontWeight: 500 }}>Client ID</span>, and <span style={{ fontWeight: 500 }}>Client Secret</span> to add them below in Step 4.</li>
                  </ul>
                </li>
                <li style={{ marginBottom: 10, lineHeight: 1.5 }}>
                  <span style={{ fontWeight: 500, fontSize: 15 }}>Step 2: Create Application Access Policy </span>
                  <span style={{ fontWeight: 'normal', color: '#888', fontSize: 14 }}>(optional but recommended)</span>
                  <ul style={{ marginTop: 5, paddingLeft: 50, lineHeight: 1.5 }}>
                    <li style={{ marginBottom: 6, fontSize: 14 }}>This step restricts the app to access only specific mailboxes. Run the following PowerShell command:</li>
                    <pre style={{ background: '#f8f9fa', padding: '12px', borderRadius: '6px', fontSize: 13, marginTop: 8, marginBottom: 0, border: '1px solid #e3e6ed', lineHeight: 1.5 }}>
                      {`New-ApplicationAccessPolicy -AppId <your-app-id> -PolicyScopeGroupId <email-automation-group> -AccessRight RestrictAccess -Description "Restrict to defined mailboxes"`}
                    </pre>
                  </ul>
                </li>
                <li style={{ marginBottom: 5, lineHeight: 1.5 }}>
                  <span style={{ fontWeight: 500, fontSize: 15 }}>Step 3: Add your mailbox to the group</span>
                </li>
                <li style={{ marginBottom: 10, lineHeight: 1.5 }}>
                  <span style={{ fontWeight: 500, fontSize: 15 }}>Step 4: Add credentials</span>
                  <ul style={{ marginTop: 5, paddingLeft: 50, lineHeight: 1.5 }}>
                    <li style={{ fontSize: 14 }}>Paste the values from Step 1 below:</li>
                  </ul>
                </li>
              </ol>
            </Col>
          </Row>
        </div>
        <Separator className="mx-3"/>
        <Form className="mb-4 p-3">
          <Row form>
            <Col md={12}>
          <h5 className="mb-3">App Registration Information</h5>
              <FormGroup>
                <Label for="clientId">Client ID</Label>
                <Input
                  type="text"
                  name="clientId"
                  id="clientId"
                  placeholder="Enter Azure Client ID"
                  value={settings.clientId}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row form>
            <Col md={12}>
              <FormGroup>
                <Label for="clientSecret">Client Secret</Label>
                <Input
                  type="text"
                  name="clientSecret"
                  id="clientSecret"
                  placeholder="Enter Azure Client Secret"
                  value={settings.clientSecret}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row form>
            <Col md={12}>
              <FormGroup>
                <Label for="tenantId">Tenant ID</Label>
                <Input
                  type="text"
                  name="tenantId"
                  id="tenantId"
                  placeholder="Enter Azure Tenant ID"
                  value={settings.tenantId}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
          </Row>

          <Separator className="mb-3" />
          <Colxx md="12" className="text-center">
            <Button
              color="primary"
              size="xs"
              onClick={handleSave}
              disabled={isLoading}
            >
              {isLoading ? 'Saving...' : 'Save'}
            </Button>
          </Colxx>
        </Form>
      </CardBody>
    </Card>
  );
}